const fillServerErrors = require('../../../common/components/servererrorfiller');
const _ = require('lodash');
/**
 * @author Francis Stalin
 * @component SignupFormDirective
 * @version 1.1
 *
 * This directive is used to register user.
 *
 * Usage:
 <wow-signup-form></wow-signup-form>
 *
 **/
module.exports = function ($state, signupService, $sce, ageCalculatorService, currentUserService, settingsService, googleCaptchaService, passwordValidationService, $rootScope) {
    return {
        restrict: 'E',
        template: require('./signup-form-template.html').trim(),
        scope: {},
        link(scope, elem) {
            if (!currentUserService.currentUser.isGuest) {
                $state.go('shop.myaccount');
                return;
            }
            scope.selectNewsLetter = false;
            scope.selectRewardCard = false;
            scope.loading = false;
            scope.isEligible = false;
            scope.useNewWowRewardsLinkingUI = false;
            scope.reCaptchaError = null;
            scope.showReCaptchaErrorMessage = false;
            scope.passwordPatternError = passwordValidationService.passwordPatternError;
            scope.passwordHint = passwordValidationService.passwordHint;
            scope.isAddingNewAddress = { mode: true }; // scope for 'store-locator-search-directive'
            scope.addressStoreLocatorSearch = {}; // scope for 'store-locator-search-directive' to sync selected location

            const EVENTS = {
                DISPLAY_NEWSLETTER_SUBSCRIPTION: 'displayNewsletterSubscription'
            };

            let noAddressResult = false;
            const minLocationSearchLength = 2;

            function validateMarketingInfo(formScope) {
                let ret = false;

                if (!formScope || !formScope.autoComplete) {
                    return ret;
                }

                const currentAutoCompleteValue = formScope.autoComplete.$viewValue;

                scope.$broadcast('validateLocation', currentAutoCompleteValue);

                if (!currentAutoCompleteValue || currentAutoCompleteValue.length < minLocationSearchLength) {
                    return ret;
                }

                if (
                    formScope.$valid &&
                    scope.addressStoreLocatorSearch.suburb &&
                    scope.addressStoreLocatorSearch.state &&
                    scope.addressStoreLocatorSearch.postcode
                ) {
                    ret = noAddressResult === false;
                }

                return ret;
            }

            //Signup user detail request mapping object.
            scope.userDetails = {
                FirstName: null,
                LastName: null,
                EmailAddress: $state.params.email || null,
                Password: null,
                DateOfBirth: null,
                MobilePhone: null,
                TypeOfDeliveryMethod: 'DecideLater',
                BeerChecked: true,
                SpiritsChecked: true,
                WineChecked: true,
                TermsAndConditions: false
            };

            scope.htmlTooltip = $sce.trustAsHtml(scope.passwordHint);

            settingsService.getSettingValue('EverydayRewards', 'EdrRegistrationToolTip')
                .then(function (response) {
                    const settingValue = response;
                    scope.htmlTooltipEDRPassword = $sce.trustAsHtml('<p class="tooltip_message">' + settingValue + '</p>');

                });

            settingsService.getSettingValue('DPU', 'NewUIEnabled')
                .then((response) => scope.useNewWowRewardsLinkingUI = response);

            scope.passwordPattern = passwordValidationService.getPattern();

            const subscribeToNewsLetter = (checked) => {
              return {
                OptInOnlineMedia: checked,
                OptInTelephone: checked,
                OptInMail: checked,
                OptInInPerson: checked,
                OptInEmail: checked,
                OptInPushAlerts: checked,
                OptInSms: checked,
                OptInMms: checked,
                OptInFreeSamples: checked,
                OptInFavourites: checked,
                OptInFavouritesSms: checked
              };
            };

            scope.checkEligibility = function () {
                if (scope.signupForm.DateOfBirth.$valid && ageCalculatorService.calculate(scope.userDetails.DateOfBirth) >= 18) {
                    scope.isEligible = true;
                } else {
                    scope.isEligible = false;
                }
            };

            scope.submitSignup = function () {
                fillServerErrors.clearForm(scope.signupForm, scope);
                scope.showReCaptchaErrorMessage = false;

                if (!scope.signupForm.$valid || !validateMarketingInfo(scope.signupForm)) {
                    return false;
                }

                if (ageCalculatorService.calculate(scope.userDetails.DateOfBirth) >= 18) {
                    scope.isEligible = true;
                } else {
                    scope.isEligible = false;
                    return false;
                }

                scope.isEligible = true;
                scope.loading = true;
                scope.signupValidationMessage = null;

                // add suburb data to scope.userDetails
                scope.userDetails.postcode = scope.addressStoreLocatorSearch.postcode || '';
                scope.userDetails.state = scope.addressStoreLocatorSearch.state || '';
                scope.userDetails.suburb = scope.addressStoreLocatorSearch.suburb || '';

                _.assign(scope.userDetails, subscribeToNewsLetter(scope.selectNewsLetter));

                googleCaptchaService
                    .execute(googleCaptchaService.ReCaptchaActions.Signup)
                    .then((token) => {
                        const reCaptchaConfig = {
                            token,
                            action: googleCaptchaService.ReCaptchaActions.Signup,
                            version: 'v3'
                        };

                        signupService
                            .signup(scope.userDetails, reCaptchaConfig)
                            .then(function (res) {
                                scope.loading = false;
                                if (res.Success) {
                                    $state.go('shop.myaccount');
                                } else {
                                    scope.signupValidationErrors = res.FieldErrors;
                                    scope.signupValidationMessage = res.Message;

                                    fillServerErrors.fillForm(scope.signupForm, res.FieldErrors, scope);
                                }
                            });
                    })
                    .catch((error) => {
                        scope.loading = false;
                        scope.reCaptchaError = error;
                        scope.showReCaptchaErrorMessage = true;
                    });
            };

            // ------------------- Analytics --------------------- //

            // check when the form become dirty for the first time
            // send an event to analytics service
            const atmFormWatcher = scope.$watch('userDetails', () => {
                if (scope.signupForm.$dirty) {
                    signupService.registrationStart();
                    atmFormWatcher(); // remove the watcher
                }
            }, true);

            // get the last dirty field and save it for atmRegistrationAbandoned
            elem.find('.input').on('focus', (data) => {
                if (data && data.currentTarget && data.currentTarget.id) {
                    scope.lastFocusedField = data.currentTarget.id;
                }
            });


            scope.$on('noResults', function(event, data) {
                noAddressResult = data;
            });

            //  check when this directive is destroyed and fire an event to analytics
            scope.$on('$destroy', () => {
                signupService.registrationAbandoned(scope.lastFocusedField);

                $rootScope.$emit(EVENTS.DISPLAY_NEWSLETTER_SUBSCRIPTION, true);
            });

            // hide footer newsletter subscription
            $rootScope.$emit(EVENTS.DISPLAY_NEWSLETTER_SUBSCRIPTION, false);
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/signup/signup-form-directive.js
 **/